import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';

export const getOneCmsBaseURLSelector = createConfigSelector('oneCMSInternetSSRBaseUrl');

export const getTravelFeatureFlagsOneCmsUrlSelector = createSelector(
  getOneCmsBaseURLSelector,
  (oneCmsDomain) => `${oneCmsDomain}/Internet/travel/featureFlags/featureFlags.json`
);
